import React from "react";
import { Link } from "react-router-dom";
import { Globe2 } from "lucide-react";

const browsers = [
  ["chrome", "Chrome", "Chrome Web Store path"],
  ["edge", "Edge", "Microsoft Edge Add-ons path"],
  ["firefox", "Firefox", "Mozilla Add-ons or signed XPI"],
  ["safari", "Safari", "Safari extension app path"],
];

export default function BrowserChoiceGrid({ prefix = "" }) {
  return (
    <section className="mt-8">
      <h2 className="text-2xl font-black">Choose your browser manually</h2>
      <div className="mt-4 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {browsers.map(([slug, name, text]) => (
          <Link key={slug} to={`${prefix}/extensions/${slug}`} className="rounded-[1.5rem] border border-border bg-card p-5 shadow-lg shadow-ocean/5 hover:border-primary/50">
            <Globe2 className="h-7 w-7 text-primary" />
            <h3 className="mt-3 text-xl font-black">{name}</h3>
            <p className="mt-2 text-sm leading-6 text-muted-foreground">{text}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}